import { RadioGroup } from '@Components/common';
import { QuestionChoice } from '@Types';

export interface SingleChoiceQuestionProps {
  identifier: string;
  label: string;
  required: boolean;
  choices: QuestionChoice[];
  typeIdentifier: string;
  disabled?: boolean;
}

export const SingleChoiceQuestion = ({
  identifier,
  required,
  choices,
  disabled,
}: SingleChoiceQuestionProps) => {
  const items = choices.map((choice) => {
    return {
      label: choice.name,
      value: choice.value,
    };
  });

  return (
    <RadioGroup
      name={identifier}
      label={''}
      items={items}
      required={required}
      disabled={disabled}
    />
  );
};
